// Institute of Design and Innovation (email idi@unm.edu). //

import Quill from 'quill/core'

import Toolbar from 'quill/modules/toolbar'
import Snow from 'quill/themes/snow'

import Bold from 'quill/formats/bold'
import Italic from 'quill/formats/italic'
import List, { ListItem } from 'quill/formats/list'
import Underline from 'quill/formats/underline'
import BlockBlot from 'quill/blots/block'
import Link from 'quill/formats/link'
BlockBlot.tagName = 'DIV'

/**
 * Register Quill object
 */
Quill.register({
  'modules/toolbar': Toolbar,
  'themes/snow': Snow,
  'formats/bold': Bold,
  'formats/italic': Italic,
  'formats/list': List,
  'formats/list-item': ListItem,
  'formats/underline': Underline,
  'formats/link': Link,
  'blots/block': BlockBlot
})

export default Quill
